/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
  "data": {
    "currencies": {
      "ADP": {
        "displayName": {
          "one": "Andorra peseeta",
          "other": "Andorra peseetat"
        },
        "narrow": "ADP",
        "symbol": "ADP"
      },
      "AED": {
        "displayName": {
          "one": "Araabia Ühendemiraatide dirhem",
          "other": "Araabia Ühendemiraatide dirhemit"
        },
        "narrow": "AED",
        "symbol": "AED"
      },
      "AFA": {
        "displayName": {
          "one": "Afganistani afgaani (1927–2002)",
          "other": "Afganistani afgaanit (1927–2002)"
        },
        "narrow": "AFA",
        "symbol": "AFA"
      },
      "AFN": {
        "displayName": {
          "one": "Afganistani afgaani",
          "other": "Afganistani afgaanit"
        },
        "narrow": "؋",
        "symbol": "AFN"
      },
      "ALK": {
        "displayName": {
          "one": "Albaania lekk (1946–1965)",
          "other": "Albaania lekki (1946–1965)"
        },
        "narrow": "ALK",
        "symbol": "ALK"
      },
      "ALL": {
        "displayName": {
          "one": "Albaania lekk",
          "other": "Albaania lekki"
        },
        "narrow": "ALL",
        "symbol": "ALL"
      },
      "AMD": {
        "displayName": {
          "one": "Armeenia dramm",
          "other": "Armeenia drammi"
        },
        "narrow": "֏",
        "symbol": "AMD"
      },
      "ANG": {
        "displayName": {
          "one": "Hollandi Antillide kulden",
          "other": "Hollandi Antillide kuldnat"
        },
        "narrow": "ANG",
        "symbol": "ANG"
      },
      "AOA": {
        "displayName": {
          "one": "Angola kvanza",
          "other": "Angola kvanzat"
        },
        "narrow": "Kz",
        "symbol": "AOA"
      },
      "AOK": {
        "displayName": {
          "one": "Angola kvanza (1977–1990)",
          "other": "Angola kvanzat (1977–1990)"
        },
        "narrow": "AOK",
        "symbol": "AOK"
      },
      "AON": {
        "displayName": {
          "one": "Angola kvanza (1990–2000)",
          "other": "Angola kvanzat (1990–2000)"
        },
        "narrow": "AON",
        "symbol": "AON"
      },
      "AOR": {
        "displayName": {
          "other": "Angola reformitud kvanza, 1995–1999"
        },
        "narrow": "AOR",
        "symbol": "AOR"
      },
      "ARA": {
        "displayName": {
          "other": "Argentina austral"
        },
        "narrow": "ARA",
        "symbol": "ARA"
      },
      "ARM": {
        "displayName": {
          "one": "Argentina peeso (1881–1970)",
          "other": "Argentina peesot (1881–1970)"
        },
        "narrow": "ARM",
        "symbol": "ARM"
      },
      "ARP": {
        "displayName": {
          "one": "Argentina peeso (1983–1985)",
          "other": "Argentina peesot (1983–1985)"
        },
        "narrow": "ARP",
        "symbol": "ARP"
      },
      "ARS": {
        "displayName": {
          "one": "Argentina peeso",
          "other": "Argentina peesot"
        },
        "narrow": "$",
        "symbol": "ARS"
      },
      "ATS": {
        "displayName": {
          "one": "Austria šilling",
          "other": "Austria šillingit"
        },
        "narrow": "ATS",
        "symbol": "ATS"
      },
      "AUD": {
        "displayName": {
          "one": "Austraalia dollar",
          "other": "Austraalia dollarit"
        },
        "narrow": "$",
        "symbol": "AU$"
      },
      "AWG": {
        "displayName": {
          "one": "Aruba kulden",
          "other": "Aruba kuldnat"
        },
        "narrow": "AWG",
        "symbol": "AWG"
      },
      "AZM": {
        "displayName": {
          "one": "Aserbaidžaani manat (1993–2006)",
          "other": "Aserbaidžaani manatit (1993–2006)"
        },
        "narrow": "AZM",
        "symbol": "AZM"
      },
      "AZN": {
        "displayName": {
          "one": "Aserbaidžaani manat",
          "other": "Aserbaidžaani manatit"
        },
        "narrow": "₼",
        "symbol": "AZN"
      },
      "BAD": {
        "displayName": {
          "one": "Bosnia ja Hertsegoviina dinaar (1992–1994)",
          "other": "Bosnia ja Hertsegoviina dinaari (1992–1994)"
        },
        "narrow": "BAD",
        "symbol": "BAD"
      },
      "BAM": {
        "displayName": {
          "one": "Bosnia ja Hertsegoviina konverteeritav mark",
          "other": "Bosnia ja Hertsegoviina konverteeritavat marka"
        },
        "narrow": "KM",
        "symbol": "BAM"
      },
      "BAN": {
        "displayName": {
          "one": "Bosnia ja Hertsegoviina uus dinaar (1994–1997)",
          "other": "Bosnia ja Hertsegoviina uut dinaari (1994–1997)"
        },
        "narrow": "BAN",
        "symbol": "BAN"
      },
      "BBD": {
        "displayName": {
          "one": "Barbadose dollar",
          "other": "Barbadose dollarit"
        },
        "narrow": "$",
        "symbol": "BBD"
      },
      "BDT": {
        "displayName": {
          "one": "Bangladeshi taka",
          "other": "Bangladeshi takat"
        },
        "narrow": "৳",
        "symbol": "BDT"
      },
      "BEC": {
        "displayName": {
          "one": "Belgia konverteeritav frank",
          "other": "Belgia konverteeritavat franki"
        },
        "narrow": "BEC",
        "symbol": "BEC"
      },
      "BEF": {
        "displayName": {
          "one": "Belgia frank",
          "other": "Belgia franki"
        },
        "narrow": "BEF",
        "symbol": "BEF"
      },
      "BEL": {
        "displayName": {
          "other": "Belgia arveldusfrank"
        },
        "narrow": "BEL",
        "symbol": "BEL"
      },
      "BGL": {
        "displayName": {
          "other": "Bulgaaria püsiv leev"
        },
        "narrow": "BGL",
        "symbol": "BGL"
      },
      "BGN": {
        "displayName": {
          "one": "Bulgaaria leev",
          "other": "Bulgaaria leevi"
        },
        "narrow": "BGN",
        "symbol": "BGN"
      },
      "BGO": {
        "displayName": {
          "one": "Bulgaaria leev (1879–1952)",
          "other": "Bulgaaria leevi (1879–1952)"
        },
        "narrow": "BGO",
        "symbol": "BGO"
      },
      "BHD": {
        "displayName": {
          "one": "Bahreini dinaar",
          "other": "Bahreini dinaari"
        },
        "narrow": "BHD",
        "symbol": "BHD"
      },
      "BIF": {
        "displayName": {
          "one": "Burundi frank",
          "other": "Burundi franki"
        },
        "narrow": "BIF",
        "symbol": "BIF"
      },
      "BMD": {
        "displayName": {
          "one": "Bermuda dollar",
          "other": "Bermuda dollarit"
        },
        "narrow": "$",
        "symbol": "BMD"
      },
      "BND": {
        "displayName": {
          "one": "Brunei dollar",
          "other": "Brunei dollarit"
        },
        "narrow": "$",
        "symbol": "BND"
      },
      "BOB": {
        "displayName": {
          "one": "Boliivia boliviaano",
          "other": "Boliivia boliviaanot"
        },
        "narrow": "Bs",
        "symbol": "BOB"
      },
      "BOL": {
        "displayName": {
          "one": "Boliivia boliviaano (1863–1963)",
          "other": "Boliivia boliviaanot (1863–1963)"
        },
        "narrow": "BOL",
        "symbol": "BOL"
      },
      "BOP": {
        "displayName": {
          "one": "Boliivia peeso",
          "other": "Boliivia peesot"
        },
        "narrow": "BOP",
        "symbol": "BOP"
      },
      "BRB": {
        "displayName": {
          "one": "Brasiilia uus kruseiro (1967–1986)",
          "other": "Brasiilia uut kruseirot (1967–1986)"
        },
        "narrow": "BRB",
        "symbol": "BRB"
      },
      "BRC": {
        "displayName": {
          "other": "Brasiilia krusado"
        },
        "narrow": "BRC",
        "symbol": "BRC"
      },
      "BRE": {
        "displayName": {
          "one": "Brasiilia kruseiro (1990–1993)",
          "other": "Brasiilia kruseirot (1990–1993)"
        },
        "narrow": "BRE",
        "symbol": "BRE"
      },
      "BRL": {
        "displayName": {
          "one": "Brasiilia reaal",
          "other": "Brasiilia reaali"
        },
        "narrow": "R$",
        "symbol": "R$"
      },
      "BRR": {
        "displayName": {
          "one": "Brasiilia kruseiro (1993–1994)",
          "other": "Brasiilia kruseirot (1993–1994)"
        },
        "narrow": "BRR",
        "symbol": "BRR"
      },
      "BRZ": {
        "displayName": {
          "one": "Brasiilia kruseiro (1942–1967)",
          "other": "Brasiilia kruseirot (1942–1967)"
        },
        "narrow": "BRZ",
        "symbol": "BRZ"
      },
      "BSD": {
        "displayName": {
          "one": "Bahama dollar",
          "other": "Bahama dollarit"
        },
        "narrow": "$",
        "symbol": "BSD"
      },
      "BTN": {
        "displayName": {
          "one": "Bhutani ngultrum",
          "other": "Bhutani ngultrumit"
        },
        "narrow": "BTN",
        "symbol": "BTN"
      },
      "BUK": {
        "displayName": {
          "one": "Birma kjatt",
          "other": "Birma kjatti"
        },
        "narrow": "BUK",
        "symbol": "BUK"
      },
      "BWP": {
        "displayName": {
          "one": "Botswana pula",
          "other": "Botswana pulat"
        },
        "narrow": "P",
        "symbol": "BWP"
      },
      "BYB": {
        "displayName": {
          "one": "Valgevene uus rubla (1994–1999)",
          "other": "Valgevene uut rubla (1994–1999)"
        },
        "narrow": "BYB",
        "symbol": "BYB"
      },
      "BYN": {
        "displayName": {
          "other": "Valgevene rubla"
        },
        "narrow": "BYN",
        "symbol": "BYN"
      },
      "BYR": {
        "displayName": {
          "other": "Valgevene rubla (2000–2016)"
        },
        "narrow": "BYR",
        "symbol": "BYR"
      },
      "BZD": {
        "displayName": {
          "one": "Belize’i dollar",
          "other": "Belize’i dollarit"
        },
        "narrow": "$",
        "symbol": "BZD"
      },
      "CAD": {
        "displayName": {
          "one": "Kanada dollar",
          "other": "Kanada dollarit"
        },
        "narrow": "$",
        "symbol": "CA$"
      },
      "CDF": {
        "displayName": {
          "one": "Kongo frank",
          "other": "Kongo franki"
        },
        "narrow": "CDF",
        "symbol": "CDF"
      },
      "CHF": {
        "displayName": {
          "one": "Šveitsi frank",
          "other": "Šveitsi franki"
        },
        "narrow": "CHF",
        "symbol": "CHF"
      },
      "CLE": {
        "displayName": {
          "one": "Tšiili eskuudo",
          "other": "Tšiili eskuudot"
        },
        "narrow": "CLE",
        "symbol": "CLE"
      },
      "CLP": {
        "displayName": {
          "one": "Tšiili peeso",
          "other": "Tšiili peesot"
        },
        "narrow": "$",
        "symbol": "CLP"
      },
      "CNH": {
        "displayName": {
          "one": "Hiina jüaan (välismaine turg)",
          "other": "Hiina jüaani (välismaine turg)"
        },
        "narrow": "CNH",
        "symbol": "CNH"
      },
      "CNY": {
        "displayName": {
          "one": "Hiina jüaan",
          "other": "Hiina jüaani"
        },
        "narrow": "¥",
        "symbol": "CN¥"
      },
      "COP": {
        "displayName": {
          "one": "Colombia peeso",
          "other": "Colombia peesot"
        },
        "narrow": "$",
        "symbol": "COP"
      },
      "CRC": {
        "displayName": {
          "one": "Costa Rica koloon",
          "other": "Costa Rica kolooni"
        },
        "narrow": "₡",
        "symbol": "CRC"
      },
      "CSD": {
        "displayName": {
          "one": "Serbia dinaar (2002–2006)",
          "other": "Serbia dinaari (2002–2006)"
        },
        "narrow": "CSD",
        "symbol": "CSD"
      },
      "CUC": {
        "displayName": {
          "one": "Kuuba konverteeritav peeso",
          "other": "Kuuba konverteeritavat peesot"
        },
        "narrow": "$",
        "symbol": "CUC"
      },
      "CUP": {
        "displayName": {
          "one": "Kuuba peeso",
          "other": "Kuuba peesot"
        },
        "narrow": "$",
        "symbol": "CUP"
      },
      "CVE": {
        "displayName": {
          "one": "Cabo Verde eskuudo",
          "other": "Cabo Verde eskuudot"
        },
        "narrow": "CVE",
        "symbol": "CVE"
      },
      "CYP": {
        "displayName": {
          "one": "Küprose nael",
          "other": "Küprose naela"
        },
        "narrow": "CYP",
        "symbol": "CYP"
      },
      "CZK": {
        "displayName": {
          "one": "Tšehhi kroon",
          "other": "Tšehhi krooni"
        },
        "narrow": "Kč",
        "symbol": "CZK"
      },
      "DDM": {
        "displayName": {
          "one": "Ida-Saksa mark",
          "other": "Ida-Saksa marka"
        },
        "narrow": "DDM",
        "symbol": "DDM"
      },
      "DEM": {
        "displayName": {
          "one": "Saksa mark",
          "other": "Saksa marka"
        },
        "narrow": "DEM",
        "symbol": "DEM"
      },
      "DJF": {
        "displayName": {
          "one": "Djibouti frank",
          "other": "Djibouti franki"
        },
        "narrow": "DJF",
        "symbol": "DJF"
      },
      "DKK": {
        "displayName": {
          "one": "Taani kroon",
          "other": "Taani krooni"
        },
        "narrow": "kr",
        "symbol": "DKK"
      },
      "DOP": {
        "displayName": {
          "one": "Dominikaani peeso",
          "other": "Dominikaani peesot"
        },
        "narrow": "$",
        "symbol": "DOP"
      },
      "DZD": {
        "displayName": {
          "one": "Alžeeria dinaar",
          "other": "Alžeeria dinaari"
        },
        "narrow": "DZD",
        "symbol": "DZD"
      },
      "ECS": {
        "displayName": {
          "one": "Ecuadori sukre",
          "other": "Ecuadori sukret"
        },
        "narrow": "ECS",
        "symbol": "ECS"
      },
      "EEK": {
        "displayName": {
          "one": "Eesti kroon",
          "other": "Eesti krooni"
        },
        "narrow": "kr",
        "symbol": "kr"
      },
      "EGP": {
        "displayName": {
          "one": "Egiptuse nael",
          "other": "Egiptuse naela"
        },
        "narrow": "E£",
        "symbol": "EGP"
      },
      "ERN": {
        "displayName": {
          "one": "Eritrea nakfa",
          "other": "Eritrea nakfat"
        },
        "narrow": "ERN",
        "symbol": "ERN"
      },
      "ESP": {
        "displayName": {
          "one": "Hispaania peseeta",
          "other": "Hispaania peseetat"
        },
        "narrow": "₧",
        "symbol": "ESP"
      },
      "ETB": {
        "displayName": {
          "one": "Etioopia birr",
          "other": "Etioopia birri"
        },
        "narrow": "ETB",
        "symbol": "ETB"
      },
      "EUR": {
        "displayName": {
          "one": "euro",
          "other": "eurot"
        },
        "narrow": "€",
        "symbol": "€"
      },
      "FIM": {
        "displayName": {
          "one": "Soome mark",
          "other": "Soome marka"
        },
        "narrow": "FIM",
        "symbol": "FIM"
      },
      "FJD": {
        "displayName": {
          "one": "Fidži dollar",
          "other": "Fidži dollarit"
        },
        "narrow": "$",
        "symbol": "FJD"
      },
      "FKP": {
        "displayName": {
          "one": "Falklandi saarte nael",
          "other": "Falklandi saarte naela"
        },
        "narrow": "£",
        "symbol": "FKP"
      },
      "FRF": {
        "displayName": {
          "one": "Prantsuse frank",
          "other": "Prantsuse franki"
        },
        "narrow": "FRF",
        "symbol": "FRF"
      },
      "GBP": {
        "displayName": {
          "one": "Suurbritannia naelsterling",
          "other": "Suurbritannia naelsterlingit"
        },
        "narrow": "£",
        "symbol": "£"
      },
      "GEL": {
        "displayName": {
          "other": "Gruusia lari"
        },
        "narrow": "₾",
        "symbol": "GEL"
      },
      "GHC": {
        "displayName": {
          "one": "Ghana sedi (1979–2007)",
          "other": "Ghana sedit (1979–2007)"
        },
        "narrow": "GHC",
        "symbol": "GHC"
      },
      "GHS": {
        "displayName": {
          "one": "Ghana sedi",
          "other": "Ghana sedit"
        },
        "narrow": "GH₵",
        "symbol": "GHS"
      },
      "GIP": {
        "displayName": {
          "one": "Gibraltari nael",
          "other": "Gibraltari naela"
        },
        "narrow": "£",
        "symbol": "GIP"
      },
      "GMD": {
        "displayName": {
          "one": "Gambia dalasi",
          "other": "Gambia dalasit"
        },
        "narrow": "GMD",
        "symbol": "GMD"
      },
      "GNF": {
        "displayName": {
          "one": "Guinea frank",
          "other": "Guinea franki"
        },
        "narrow": "FG",
        "symbol": "GNF"
      },
      "GNS": {
        "displayName": {
          "other": "Guinea syli"
        },
        "narrow": "GNS",
        "symbol": "GNS"
      },
      "GRD": {
        "displayName": {
          "one": "Kreeka drahm",
          "other": "Kreeka drahmi"
        },
        "narrow": "GRD",
        "symbol": "GRD"
      },
      "GTQ": {
        "displayName": {
          "one": "Guatemala ketsaal",
          "other": "Guatemala ketsaali"
        },
        "narrow": "Q",
        "symbol": "GTQ"
      },
      "GWE": {
        "displayName": {
          "one": "Portugali Guinea eskuudo",
          "other": "Portugali Guinea eskuudot"
        },
        "narrow": "GWE",
        "symbol": "GWE"
      },
      "GWP": {
        "displayName": {
          "one": "Guinea-Bissau peeso",
          "other": "Guinea-Bissau peesot"
        },
        "narrow": "GWP",
        "symbol": "GWP"
      },
      "GYD": {
        "displayName": {
          "one": "Guyana dollar",
          "other": "Guyana dollarit"
        },
        "narrow": "$",
        "symbol": "GYD"
      },
      "HKD": {
        "displayName": {
          "one": "Hongkongi dollar",
          "other": "Hongkongi dollarit"
        },
        "narrow": "$",
        "symbol": "HK$"
      },
      "HNL": {
        "displayName": {
          "one": "Hondurase lempiira",
          "other": "Hondurase lempiirat"
        },
        "narrow": "L",
        "symbol": "HNL"
      },
      "HRD": {
        "displayName": {
          "one": "Horvaatia dinaar",
          "other": "Horvaatia dinaari"
        },
        "narrow": "HRD",
        "symbol": "HRD"
      },
      "HRK": {
        "displayName": {
          "other": "Horvaatia kuna"
        },
        "narrow": "kn",
        "symbol": "HRK"
      },
      "HTG": {
        "displayName": {
          "one": "Haiti gurd",
          "other": "Haiti gurdi"
        },
        "narrow": "HTG",
        "symbol": "HTG"
      },
      "HUF": {
        "displayName": {
          "one": "Ungari forint",
          "other": "Ungari forintit"
        },
        "narrow": "Ft",
        "symbol": "HUF"
      },
      "IDR": {
        "displayName": {
          "one": "Indoneesia ruupia",
          "other": "Indoneesia ruupiat"
        },
        "narrow": "Rp",
        "symbol": "IDR"
      },
      "IEP": {
        "displayName": {
          "one": "Iiri nael",
          "other": "Iiri naela"
        },
        "narrow": "IEP",
        "symbol": "IEP"
      },
      "ILP": {
        "displayName": {
          "one": "Iisraeli nael",
          "other": "Iisraeli naela"
        },
        "narrow": "ILP",
        "symbol": "ILP"
      },
      "ILR": {
        "displayName": {
          "one": "Iisraeli seekel (1980–1985)",
          "other": "Iisraeli seekelit (1980–1985)"
        },
        "narrow": "ILR",
        "symbol": "ILR"
      },
      "ILS": {
        "displayName": {
          "one": "Iisraeli uus seekel",
          "other": "Iisraeli uut seeklit"
        },
        "narrow": "₪",
        "symbol": "₪"
      },
      "INR": {
        "displayName": {
          "one": "India ruupia",
          "other": "India ruupiat"
        },
        "narrow": "₹",
        "symbol": "₹"
      },
      "IQD": {
        "displayName": {
          "one": "Iraagi dinaar",
          "other": "Iraagi dinaari"
        },
        "narrow": "IQD",
        "symbol": "IQD"
      },
      "IRR": {
        "displayName": {
          "one": "Iraani riaal",
          "other": "Iraani riaali"
        },
        "narrow": "IRR",
        "symbol": "IRR"
      },
      "ISJ": {
        "displayName": {
          "one": "Islandi kroon (1918–1981)",
          "other": "Islandi krooni (1918–1981)"
        },
        "narrow": "ISJ",
        "symbol": "ISJ"
      },
      "ISK": {
        "displayName": {
          "one": "Islandi kroon",
          "other": "Islandi krooni"
        },
        "narrow": "kr",
        "symbol": "ISK"
      },
      "ITL": {
        "displayName": {
          "one": "Itaalia liir",
          "other": "Itaalia liiri"
        },
        "narrow": "ITL",
        "symbol": "ITL"
      },
      "JMD": {
        "displayName": {
          "one": "Jamaica dollar",
          "other": "Jamaica dollarit"
        },
        "narrow": "$",
        "symbol": "JMD"
      },
      "JOD": {
        "displayName": {
          "one": "Jordaania dinaar",
          "other": "Jordaania dinaari"
        },
        "narrow": "JOD",
        "symbol": "JOD"
      },
      "JPY": {
        "displayName": {
          "one": "Jaapani jeen",
          "other": "Jaapani jeeni"
        },
        "narrow": "¥",
        "symbol": "¥"
      },
      "KES": {
        "displayName": {
          "one": "Keenia šilling",
          "other": "Keenia šillingit"
        },
        "narrow": "KES",
        "symbol": "KES"
      },
      "KGS": {
        "displayName": {
          "one": "Kõrgõzstani somm",
          "other": "Kõrgõzstani sommi"
        },
        "narrow": "KGS",
        "symbol": "KGS"
      },
      "KHR": {
        "displayName": {
          "one": "Kambodža riaal",
          "other": "Kambodža riaali"
        },
        "narrow": "៛",
        "symbol": "KHR"
      },
      "KMF": {
        "displayName": {
          "one": "Komoori frank",
          "other": "Komoori franki"
        },
        "narrow": "CF",
        "symbol": "KMF"
      },
      "KPW": {
        "displayName": {
          "one": "Põhja-Korea vonn",
          "other": "Põhja-Korea vonni"
        },
        "narrow": "₩",
        "symbol": "KPW"
      },
      "KRO": {
        "displayName": {
          "one": "Lõuna-Korea vonn (1945–1953)",
          "other": "Lõuna-Korea vonni (1945–1953)"
        },
        "narrow": "KRO",
        "symbol": "KRO"
      },
      "KRW": {
        "displayName": {
          "one": "Lõuna-Korea vonn",
          "other": "Lõuna-Korea vonni"
        },
        "narrow": "₩",
        "symbol": "₩"
      },
      "KWD": {
        "displayName": {
          "one": "Kuveidi dinaar",
          "other": "Kuveidi dinaari"
        },
        "narrow": "KWD",
        "symbol": "KWD"
      },
      "KYD": {
        "displayName": {
          "one": "Kaimanisaarte dollar",
          "other": "Kaimanisaarte dollarit"
        },
        "narrow": "$",
        "symbol": "KYD"
      },
      "KZT": {
        "displayName": {
          "one": "Kasahstani tenge",
          "other": "Kasahstani tenget"
        },
        "narrow": "₸",
        "symbol": "KZT"
      },
      "LAK": {
        "displayName": {
          "one": "Laose kiip",
          "other": "Laose kiipi"
        },
        "narrow": "₭",
        "symbol": "LAK"
      },
      "LBP": {
        "displayName": {
          "one": "Liibanoni nael",
          "other": "Liibanoni naela"
        },
        "narrow": "L£",
        "symbol": "LBP"
      },
      "LKR": {
        "displayName": {
          "one": "Sri Lanka ruupia",
          "other": "Sri Lanka ruupiat"
        },
        "narrow": "Rs",
        "symbol": "LKR"
      },
      "LRD": {
        "displayName": {
          "one": "Libeeria dollar",
          "other": "Libeeria dollarit"
        },
        "narrow": "$",
        "symbol": "LRD"
      },
      "LSL": {
        "displayName": {
          "one": "Lesotho loti",
          "other": "Lesotho lotit"
        },
        "narrow": "LSL",
        "symbol": "LSL"
      },
      "LTL": {
        "displayName": {
          "one": "Leedu litt",
          "other": "Leedu litti"
        },
        "narrow": "Lt",
        "symbol": "LTL"
      },
      "LUC": {
        "displayName": {
          "one": "Luksemburgi konverteeritav frank",
          "other": "Luksemburgi konverteeritavat franki"
        },
        "narrow": "LUC",
        "symbol": "LUC"
      },
      "LUF": {
        "displayName": {
          "one": "Luksemburgi frank",
          "other": "Luksemburgi franki"
        },
        "narrow": "LUF",
        "symbol": "LUF"
      },
      "LVL": {
        "displayName": {
          "one": "Läti latt",
          "other": "Läti latti"
        },
        "narrow": "Ls",
        "symbol": "LVL"
      },
      "LVR": {
        "displayName": {
          "other": "Läti rubla"
        },
        "narrow": "LVR",
        "symbol": "LVR"
      },
      "LYD": {
        "displayName": {
          "one": "Liibüa dinaar",
          "other": "Liibüa dinaari"
        },
        "narrow": "LYD",
        "symbol": "LYD"
      },
      "MAD": {
        "displayName": {
          "one": "Maroko dirhem",
          "other": "Maroko dirhemit"
        },
        "narrow": "MAD",
        "symbol": "MAD"
      },
      "MAF": {
        "displayName": {
          "one": "Maroko frank",
          "other": "Maroko franki"
        },
        "narrow": "MAF",
        "symbol": "MAF"
      },
      "MCF": {
        "displayName": {
          "one": "Monaco frank",
          "other": "Monaco franki"
        },
        "narrow": "MCF",
        "symbol": "MCF"
      },
      "MDL": {
        "displayName": {
          "one": "Moldova leu",
          "other": "Moldova leud"
        },
        "narrow": "MDL",
        "symbol": "MDL"
      },
      "MGA": {
        "displayName": {
          "one": "Madagaskari ariari",
          "other": "Madagaskari ariarit"
        },
        "narrow": "Ar",
        "symbol": "MGA"
      },
      "MGF": {
        "displayName": {
          "one": "Madagaskari frank",
          "other": "Madagaskar franki"
        },
        "narrow": "MGF",
        "symbol": "MGF"
      },
      "MKD": {
        "displayName": {
          "one": "Makedoonia dinaar",
          "other": "Makedoonia dinaari"
        },
        "narrow": "MKD",
        "symbol": "MKD"
      },
      "MKN": {
        "displayName": {
          "one": "Makedoonia dinaar (1992–1993)",
          "other": "Makedoonia dinaari (1992–1993)"
        },
        "narrow": "MKN",
        "symbol": "MKN"
      },
      "MLF": {
        "displayName": {
          "one": "Mali frank",
          "other": "Mali franki"
        },
        "narrow": "MLF",
        "symbol": "MLF"
      },
      "MMK": {
        "displayName": {
          "one": "Myanmari kjatt",
          "other": "Myanmari kjatti"
        },
        "narrow": "K",
        "symbol": "MMK"
      },
      "MNT": {
        "displayName": {
          "one": "Mongoolia tugrik",
          "other": "Mongoolia tugrikut"
        },
        "narrow": "₮",
        "symbol": "MNT"
      },
      "MOP": {
        "displayName": {
          "one": "Macau pataaka",
          "other": "Macau pataakat"
        },
        "narrow": "MOP",
        "symbol": "MOP"
      },
      "MRO": {
        "displayName": {
          "one": "Mauritaania ugia (1973–2017)",
          "other": "Mauritaania ugiat (1973–2017)"
        },
        "narrow": "MRO",
        "symbol": "MRO"
      },
      "MRU": {
        "displayName": {
          "one": "Mauritaania ugia",
          "other": "Mauritaania ugiat"
        },
        "narrow": "MRU",
        "symbol": "MRU"
      },
      "MTL": {
        "displayName": {
          "one": "Malta liir",
          "other": "Malta liiri"
        },
        "narrow": "MTL",
        "symbol": "MTL"
      },
      "MTP": {
        "displayName": {
          "one": "Malta nael",
          "other": "Malta naela"
        },
        "narrow": "MTP",
        "symbol": "MTP"
      },
      "MUR": {
        "displayName": {
          "one": "Mauritiuse ruupia",
          "other": "Mauritiuse ruupiat"
        },
        "narrow": "Rs",
        "symbol": "MUR"
      },
      "MVP": {
        "displayName": {
          "one": "Maldiivi ruupia (1947–1981)",
          "other": "Maldiivi ruupiat (1947–1981)"
        },
        "narrow": "MVP",
        "symbol": "MVP"
      },
      "MVR": {
        "displayName": {
          "one": "Maldiivi ruupia",
          "other": "Maldiivi ruupiat"
        },
        "narrow": "MVR",
        "symbol": "MVR"
      },
      "MWK": {
        "displayName": {
          "one": "Malawi kvatša",
          "other": "Malawi kvatšat"
        },
        "narrow": "MWK",
        "symbol": "MWK"
      },
      "MXN": {
        "displayName": {
          "one": "Mehhiko peeso",
          "other": "Mehhiko peesot"
        },
        "narrow": "$",
        "symbol": "MX$"
      },
      "MXP": {
        "displayName": {
          "one": "Mehhiko peeso (1861–1992)",
          "other": "Mehhiko peesot (1861–1992)"
        },
        "narrow": "MXP",
        "symbol": "MXP"
      },
      "MYR": {
        "displayName": {
          "one": "Malaisia ringgit",
          "other": "Malaisia ringgitit"
        },
        "narrow": "RM",
        "symbol": "MYR"
      },
      "MZE": {
        "displayName": {
          "one": "Mosambiigi eskuudo",
          "other": "Mosambiigi eskuudot"
        },
        "narrow": "MZE",
        "symbol": "MZE"
      },
      "MZM": {
        "displayName": {
          "one": "Mosambiigi metikal (1980–2006)",
          "other": "Mosambiigi metikali (1980–2006)"
        },
        "narrow": "MZM",
        "symbol": "MZM"
      },
      "MZN": {
        "displayName": {
          "one": "Mosambiigi metikal",
          "other": "Mosambiigi metikali"
        },
        "narrow": "MZN",
        "symbol": "MZN"
      },
      "NAD": {
        "displayName": {
          "one": "Namiibia dollar",
          "other": "Namiibia dollarit"
        },
        "narrow": "$",
        "symbol": "NAD"
      },
      "NGN": {
        "displayName": {
          "one": "Nigeeria naira",
          "other": "Nigeeria nairat"
        },
        "narrow": "₦",
        "symbol": "NGN"
      },
      "NIC": {
        "displayName": {
          "one": "Nicaragua kordoba (1988–1991)",
          "other": "Nicaragua kordobat (1988–1991)"
        },
        "narrow": "NIC",
        "symbol": "NIC"
      },
      "NIO": {
        "displayName": {
          "one": "Nicaragua kordoba",
          "other": "Nicaragua kordobat"
        },
        "narrow": "C$",
        "symbol": "NIO"
      },
      "NLG": {
        "displayName": {
          "one": "Hollandi kulden",
          "other": "Hollandi kuldnat"
        },
        "narrow": "NLG",
        "symbol": "NLG"
      },
      "NOK": {
        "displayName": {
          "one": "Norra kroon",
          "other": "Norra krooni"
        },
        "narrow": "kr",
        "symbol": "NOK"
      },
      "NPR": {
        "displayName": {
          "one": "Nepali ruupia",
          "other": "Nepali ruupiat"
        },
        "narrow": "Rs",
        "symbol": "NPR"
      },
      "NZD": {
        "displayName": {
          "one": "Uus-Meremaa dollar",
          "other": "Uus-Meremaa dollarit"
        },
        "narrow": "$",
        "symbol": "NZ$"
      },
      "OMR": {
        "displayName": {
          "one": "Omaani riaal",
          "other": "Omaani riaali"
        },
        "narrow": "OMR",
        "symbol": "OMR"
      },
      "PAB": {
        "displayName": {
          "one": "Panama balboa",
          "other": "Panama balboad"
        },
        "narrow": "PAB",
        "symbol": "PAB"
      },
      "PEI": {
        "displayName": {
          "other": "Peruu inti"
        },
        "narrow": "PEI",
        "symbol": "PEI"
      },
      "PEN": {
        "displayName": {
          "one": "Peruu soll",
          "other": "Peruu solli"
        },
        "narrow": "PEN",
        "symbol": "PEN"
      },
      "PES": {
        "displayName": {
          "one": "Peruu soll (1863–1965)",
          "other": "Peruu solli (1863–1965)"
        },
        "narrow": "PES",
        "symbol": "PES"
      },
      "PGK": {
        "displayName": {
          "one": "Paapua Uus-Guinea kina",
          "other": "Paapua Uus-Guinea kinat"
        },
        "narrow": "PGK",
        "symbol": "PGK"
      },
      "PHP": {
        "displayName": {
          "one": "Filipiini peeso",
          "other": "Filipiini peesot"
        },
        "narrow": "₱",
        "symbol": "PHP"
      },
      "PKR": {
        "displayName": {
          "one": "Pakistani ruupia",
          "other": "Pakistani ruupiat"
        },
        "narrow": "Rs",
        "symbol": "PKR"
      },
      "PLN": {
        "displayName": {
          "one": "Poola zlott",
          "other": "Poola zlotti"
        },
        "narrow": "zł",
        "symbol": "PLN"
      },
      "PLZ": {
        "displayName": {
          "one": "Poola zlott (1950–1995)",
          "other": "Poola zlotti (1950–1995)"
        },
        "narrow": "PLZ",
        "symbol": "PLZ"
      },
      "PTE": {
        "displayName": {
          "one": "Portugali eskuudo",
          "other": "Portugali eskuudot"
        },
        "narrow": "PTE",
        "symbol": "PTE"
      },
      "PYG": {
        "displayName": {
          "one": "Paraguay guaranii",
          "other": "Paraguay guaraniid"
        },
        "narrow": "₲",
        "symbol": "PYG"
      },
      "QAR": {
        "displayName": {
          "one": "Katari riaal",
          "other": "Katari riaali"
        },
        "narrow": "QAR",
        "symbol": "QAR"
      },
      "RHD": {
        "displayName": {
          "one": "Rodeesia dollar",
          "other": "Rodeesia dollarit"
        },
        "narrow": "RHD",
        "symbol": "RHD"
      },
      "ROL": {
        "displayName": {
          "one": "Rumeenia leu (1952–2006)",
          "other": "Rumeenia leud (1952–2006)"
        },
        "narrow": "ROL",
        "symbol": "ROL"
      },
      "RON": {
        "displayName": {
          "one": "Rumeenia leu",
          "other": "Rumeenia leud"
        },
        "narrow": "lei",
        "symbol": "RON"
      },
      "RSD": {
        "displayName": {
          "one": "Serbia dinaar",
          "other": "Serbia dinaari"
        },
        "narrow": "RSD",
        "symbol": "RSD"
      },
      "RUB": {
        "displayName": {
          "other": "Venemaa rubla"
        },
        "narrow": "₽",
        "symbol": "RUB"
      },
      "RUR": {
        "displayName": {
          "other": "Venemaa rubla (1991–1998)"
        },
        "narrow": "RUR",
        "symbol": "RUR"
      },
      "RWF": {
        "displayName": {
          "one": "Rwanda frank",
          "other": "Rwanda franki"
        },
        "narrow": "RF",
        "symbol": "RWF"
      },
      "SAR": {
        "displayName": {
          "one": "Saudi Araabia riaal",
          "other": "Saudi Araabia riaali"
        },
        "narrow": "SAR",
        "symbol": "SAR"
      },
      "SBD": {
        "displayName": {
          "one": "Saalomoni Saarte dollar",
          "other": "Saalomoni Saarte dollarit"
        },
        "narrow": "$",
        "symbol": "SBD"
      },
      "SCR": {
        "displayName": {
          "one": "Seišelli ruupia",
          "other": "Seišelli ruupiat"
        },
        "narrow": "SCR",
        "symbol": "SCR"
      },
      "SDD": {
        "displayName": {
          "one": "Sudaani dinaar (1992–2007)",
          "other": "Sudaani dinaari (1992–2007)"
        },
        "narrow": "SDD",
        "symbol": "SDD"
      },
      "SDG": {
        "displayName": {
          "one": "Sudaani nael",
          "other": "Sudaani naela"
        },
        "narrow": "SDG",
        "symbol": "SDG"
      },
      "SDP": {
        "displayName": {
          "one": "Sudaani nael (1957–1998)",
          "other": "Sudaani naela (1957–1998)"
        },
        "narrow": "SDP",
        "symbol": "SDP"
      },
      "SEK": {
        "displayName": {
          "one": "Rootsi kroon",
          "other": "Rootsi krooni"
        },
        "narrow": "kr",
        "symbol": "SEK"
      },
      "SGD": {
        "displayName": {
          "one": "Singapuri dollar",
          "other": "Singapuri dollarit"
        },
        "narrow": "$",
        "symbol": "SGD"
      },
      "SHP": {
        "displayName": {
          "one": "Saint Helena nael",
          "other": "Saint Helena naela"
        },
        "narrow": "£",
        "symbol": "SHP"
      },
      "SIT": {
        "displayName": {
          "one": "Sloveenia tolar",
          "other": "Sloveenia tolarit"
        },
        "narrow": "SIT",
        "symbol": "SIT"
      },
      "SKK": {
        "displayName": {
          "one": "Slovaki kroon",
          "other": "Slovaki krooni"
        },
        "narrow": "SKK",
        "symbol": "SKK"
      },
      "SLL": {
        "displayName": {
          "one": "Sierra Leone leoone",
          "other": "Sierra Leone leoonet"
        },
        "narrow": "SLL",
        "symbol": "SLL"
      },
      "SOS": {
        "displayName": {
          "one": "Somaalia šilling",
          "other": "Somaalia šillingit"
        },
        "narrow": "SOS",
        "symbol": "SOS"
      },
      "SRD": {
        "displayName": {
          "one": "Suriname dollar",
          "other": "Suriname dollarit"
        },
        "narrow": "$",
        "symbol": "SRD"
      },
      "SRG": {
        "displayName": {
          "one": "Suriname kulden",
          "other": "Suriname kuldnat"
        },
        "narrow": "SRG",
        "symbol": "SRG"
      },
      "SSP": {
        "displayName": {
          "one": "Lõuna-Sudaani nael",
          "other": "Lõuna-Sudaani naela"
        },
        "narrow": "£",
        "symbol": "SSP"
      },
      "STD": {
        "displayName": {
          "one": "São Tomé ja Príncipe dobra (1977–2017)",
          "other": "São Tomé ja Príncipe dobrat (1977–2017)"
        },
        "narrow": "STD",
        "symbol": "STD"
      },
      "STN": {
        "displayName": {
          "one": "São Tomé ja Príncipe dobra",
          "other": "São Tomé ja Príncipe dobrat"
        },
        "narrow": "Db",
        "symbol": "STN"
      },
      "SUR": {
        "displayName": {
          "other": "NSVL-i rubla"
        },
        "narrow": "SUR",
        "symbol": "SUR"
      },
      "SVC": {
        "displayName": {
          "one": "El Salvadori koloon",
          "other": "El Salvadori kolooni"
        },
        "narrow": "SVC",
        "symbol": "SVC"
      },
      "SYP": {
        "displayName": {
          "one": "Süüria nael",
          "other": "Süüria naela"
        },
        "narrow": "£",
        "symbol": "SYP"
      },
      "SZL": {
        "displayName": {
          "one": "Svaasimaa lilangeni",
          "other": "Svaasimaa lilangenit"
        },
        "narrow": "SZL",
        "symbol": "SZL"
      },
      "THB": {
        "displayName": {
          "one": "Tai baat",
          "other": "Tai baati"
        },
        "narrow": "฿",
        "symbol": "฿"
      },
      "TJR": {
        "displayName": {
          "other": "Tadžikistani rubla"
        },
        "narrow": "TJR",
        "symbol": "TJR"
      },
      "TJS": {
        "displayName": {
          "one": "Tadžikistani somoni",
          "other": "Tadžikistani somonit"
        },
        "narrow": "TJS",
        "symbol": "TJS"
      },
      "TMM": {
        "displayName": {
          "one": "Türkmenistani manat (1993–2009)",
          "other": "Türkmenistani manatit (1993–2009)"
        },
        "narrow": "TMM",
        "symbol": "TMM"
      },
      "TMT": {
        "displayName": {
          "one": "Türkmenistani manat",
          "other": "Türkmenistani manatit"
        },
        "narrow": "TMT",
        "symbol": "TMT"
      },
      "TND": {
        "displayName": {
          "one": "Tuneesia dinaar",
          "other": "Tuneesia dinaari"
        },
        "narrow": "TND",
        "symbol": "TND"
      },
      "TOP": {
        "displayName": {
          "one": "Tonga pa’anga",
          "other": "Tonga pa’angat"
        },
        "narrow": "T$",
        "symbol": "TOP"
      },
      "TPE": {
        "displayName": {
          "one": "Timori eskuudo",
          "other": "Timori eskuudot"
        },
        "narrow": "TPE",
        "symbol": "TPE"
      },
      "TRL": {
        "displayName": {
          "one": "Türgi liir (1922–2005)",
          "other": "Türgi liiri (1922–2005)"
        },
        "narrow": "TRL",
        "symbol": "TRL"
      },
      "TRY": {
        "displayName": {
          "one": "Türgi liir",
          "other": "Türgi liiri"
        },
        "narrow": "₺",
        "symbol": "TRY"
      },
      "TTD": {
        "displayName": {
          "one": "Trinidadi ja Tobago dollar",
          "other": "Trinidadi ja Tobago dollarit"
        },
        "narrow": "$",
        "symbol": "TTD"
      },
      "TWD": {
        "displayName": {
          "one": "uus Taiwani dollar",
          "other": "uut Taiwani dollarit"
        },
        "narrow": "NT$",
        "symbol": "NT$"
      },
      "TZS": {
        "displayName": {
          "one": "Tansaania šilling",
          "other": "Tansaania šillingit"
        },
        "narrow": "TZS",
        "symbol": "TZS"
      },
      "UAH": {
        "displayName": {
          "one": "Ukraina grivna",
          "other": "Ukraina grivnat"
        },
        "narrow": "₴",
        "symbol": "UAH"
      },
      "UAK": {
        "displayName": {
          "other": "Ukraina karbovanets"
        },
        "narrow": "UAK",
        "symbol": "UAK"
      },
      "UGS": {
        "displayName": {
          "one": "Uganda šilling (1966–1987)",
          "other": "Uganda šillingit (1966–1987)"
        },
        "narrow": "UGS",
        "symbol": "UGS"
      },
      "UGX": {
        "displayName": {
          "one": "Uganda šilling",
          "other": "Uganda šillingit"
        },
        "narrow": "UGX",
        "symbol": "UGX"
      },
      "USD": {
        "displayName": {
          "one": "USA dollar",
          "other": "USA dollarit"
        },
        "narrow": "$",
        "symbol": "$"
      },
      "USN": {
        "displayName": {
          "other": "USA järgmise päeva dollar"
        },
        "narrow": "USN",
        "symbol": "USN"
      },
      "USS": {
        "displayName": {
          "other": "USA sama päeva dollar"
        },
        "narrow": "USS",
        "symbol": "USS"
      },
      "UYP": {
        "displayName": {
          "one": "Uruguay peeso (1975–1993)",
          "other": "Uruguay peesot (1975–1993)"
        },
        "narrow": "UYP",
        "symbol": "UYP"
      },
      "UYU": {
        "displayName": {
          "one": "Uruguay peeso",
          "other": "Uruguay peesot"
        },
        "narrow": "$",
        "symbol": "UYU"
      },
      "UZS": {
        "displayName": {
          "one": "Usbekistani somm",
          "other": "Usbekistani sommi"
        },
        "narrow": "UZS",
        "symbol": "UZS"
      },
      "VEB": {
        "displayName": {
          "one": "Venezuela boliivar (1871–2008)",
          "other": "Venezuela boliivarit (1871–2008)"
        },
        "narrow": "VEB",
        "symbol": "VEB"
      },
      "VEF": {
        "displayName": {
          "one": "Venezuela boliivar (2008–2018)",
          "other": "Venezuela boliivarit (2008–2018)"
        },
        "narrow": "Bs",
        "symbol": "VEF"
      },
      "VES": {
        "displayName": {
          "one": "Venezuela boliivar",
          "other": "Venezuela boliivarit"
        },
        "narrow": "VES",
        "symbol": "VES"
      },
      "VND": {
        "displayName": {
          "one": "Vietnami dong",
          "other": "Vietnami dongi"
        },
        "narrow": "₫",
        "symbol": "₫"
      },
      "VNN": {
        "displayName": {
          "one": "Vietnami dong (1978–1985)",
          "other": "Vietnami dongi (1978–1985)"
        },
        "narrow": "VNN",
        "symbol": "VNN"
      },
      "VUV": {
        "displayName": {
          "one": "Vanuatu vatu",
          "other": "Vanuatu vatut"
        },
        "narrow": "VUV",
        "symbol": "VUV"
      },
      "WST": {
        "displayName": {
          "one": "Samoa taala",
          "other": "Samoa taalat"
        },
        "narrow": "WST",
        "symbol": "WST"
      },
      "XAF": {
        "displayName": {
          "one": "Kesk-Aafrika CFA frank",
          "other": "Kesk-Aafrika CFA franki"
        },
        "narrow": "FCFA",
        "symbol": "FCFA"
      },
      "XAG": {
        "displayName": {
          "one": "troiunts hõbedat",
          "other": "troiuntsi hõbedat"
        },
        "narrow": "XAG",
        "symbol": "XAG"
      },
      "XAU": {
        "displayName": {
          "one": "troiunts kulda",
          "other": "troiuntsi kulda"
        },
        "narrow": "XAU",
        "symbol": "XAU"
      },
      "XBA": {
        "displayName": {
          "other": "EURCO"
        },
        "narrow": "XBA",
        "symbol": "XBA"
      },
      "XBB": {
        "displayName": {
          "other": "Euroopa rahaühik"
        },
        "narrow": "XBB",
        "symbol": "XBB"
      },
      "XBC": {
        "displayName": {
          "other": "Euroopa rahaline arvestusühik (XBC)"
        },
        "narrow": "XBC",
        "symbol": "XBC"
      },
      "XBD": {
        "displayName": {
          "other": "Euroopa rahaline arvestusühik (XBD)"
        },
        "narrow": "XBD",
        "symbol": "XBD"
      },
      "XCD": {
        "displayName": {
          "one": "Ida-Kariibi dollar",
          "other": "Ida-Kariibi dollarit"
        },
        "narrow": "$",
        "symbol": "EC$"
      },
      "XDR": {
        "displayName": {
          "other": "Rahvusvahelise Valuutafondi arvestusühik"
        },
        "narrow": "XDR",
        "symbol": "XDR"
      },
      "XEU": {
        "displayName": {
          "one": "eküü",
          "other": "eküüd"
        },
        "narrow": "XEU",
        "symbol": "XEU"
      },
      "XFO": {
        "displayName": {
          "one": "Prantsuse kuldfrank",
          "other": "Prantsuse kuldfranki"
        },
        "narrow": "XFO",
        "symbol": "XFO"
      },
      "XFU": {
        "displayName": {
          "other": "Prantsuse UIC-frank"
        },
        "narrow": "XFU",
        "symbol": "XFU"
      },
      "XOF": {
        "displayName": {
          "one": "Lääne-Aafrika CFA frank",
          "other": "Lääne-Aafrika CFA franki"
        },
        "narrow": "F CFA",
        "symbol": "F CFA"
      },
      "XPD": {
        "displayName": {
          "one": "troiunts pallaadiumit",
          "other": "troiuntsi pallaadiumit"
        },
        "narrow": "XPD",
        "symbol": "XPD"
      },
      "XPF": {
        "displayName": {
          "one": "CFP frank",
          "other": "CFP franki"
        },
        "narrow": "CFPF",
        "symbol": "CFPF"
      },
      "XPT": {
        "displayName": {
          "one": "troiunts plaatinat",
          "other": "troiuntsi plaatinat"
        },
        "narrow": "XPT",
        "symbol": "XPT"
      },
      "XTS": {
        "displayName": {
          "other": "vääringute testkood"
        },
        "narrow": "XTS",
        "symbol": "XTS"
      },
      "XXX": {
        "displayName": {
          "one": "(määramata rahaühik)",
          "other": "(määramata rahaühikut)"
        },
        "narrow": "¤",
        "symbol": "¤"
      },
      "YDD": {
        "displayName": {
          "one": "Jeemeni dinaar",
          "other": "Jeemeni dinaari"
        },
        "narrow": "YDD",
        "symbol": "YDD"
      },
      "YER": {
        "displayName": {
          "one": "Jeemeni riaal",
          "other": "Jeemeni riaali"
        },
        "narrow": "YER",
        "symbol": "YER"
      },
      "YUM": {
        "displayName": {
          "one": "Jugoslaavia uus dinaar (1994–2002)",
          "other": "Jugoslaavia uut dinaari (1994–2002)"
        },
        "narrow": "YUM",
        "symbol": "YUM"
      },
      "YUN": {
        "displayName": {
          "one": "Jugoslaavia konverteeritav dinaar (1990–1992)",
          "other": "Jugoslaavia konverteeritavat dinaari (1990–1992)"
        },
        "narrow": "YUN",
        "symbol": "YUN"
      },
      "ZAR": {
        "displayName": {
          "one": "Lõuna-Aafrika rand",
          "other": "Lõuna-Aafrika randi"
        },
        "narrow": "R",
        "symbol": "ZAR"
      },
      "ZMK": {
        "displayName": {
          "one": "Sambia kvatša (1968–2012)",
          "other": "Sambia kvatšat (1968–2012)"
        },
        "narrow": "ZMK",
        "symbol": "ZMK"
      },
      "ZMW": {
        "displayName": {
          "one": "Sambia kvatša",
          "other": "Sambia kvatšat"
        },
        "narrow": "ZK",
        "symbol": "ZMW"
      },
      "ZRZ": {
        "displayName": {
          "other": "Sairi zaire"
        },
        "narrow": "ZRZ",
        "symbol": "ZRZ"
      },
      "ZWD": {
        "displayName": {
          "one": "Zimbabwe dollar (1980–2008)",
          "other": "Zimbabwe dollarit (1980–2008)"
        },
        "narrow": "ZWD",
        "symbol": "ZWD"
      },
      "ZWL": {
        "displayName": {
          "one": "Zimbabwe dollar (2009)",
          "other": "Zimbabwe dollarit (2009)"
        },
        "narrow": "ZWL",
        "symbol": "ZWL"
      },
      "ZWR": {
        "displayName": {
          "one": "Zimbabwe dollar (2008)",
          "other": "Zimbabwe dollarit (2008)"
        },
        "narrow": "ZWR",
        "symbol": "ZWR"
      }
    },
    "nu": [
      "latn"
    ],
    "numbers": {
      "currency": {
        "latn": {
          "accounting": "#,##0.00 ¤;(#,##0.00 ¤)",
          "currencySpacing": {
            "afterInsertBetween": " ",
            "beforeInsertBetween": " "
          },
          "short": {
            "1000": {
              "other": "0 tuh ¤"
            },
            "10000": {
              "other": "00 tuh ¤"
            },
            "100000": {
              "other": "000 tuh ¤"
            },
            "1000000": {
              "other": "0 mln ¤"
            },
            "10000000": {
              "other": "00 mln ¤"
            },
            "100000000": {
              "other": "000 mln ¤"
            },
            "1000000000": {
              "other": "0 mld ¤"
            },
            "10000000000": {
              "other": "00 mld ¤"
            },
            "100000000000": {
              "other": "000 mld ¤"
            },
            "1000000000000": {
              "other": "0 trln ¤"
            },
            "10000000000000": {
              "other": "00 trln ¤"
            },
            "100000000000000": {
              "other": "000 trln ¤"
            }
          },
          "standard": "#,##0.00 ¤",
          "unitPattern": "{0} {1}"
        }
      },
      "decimal": {
        "latn": {
          "long": {
            "1000": {
              "other": "0 tuhat"
            },
            "10000": {
              "other": "00 tuhat"
            },
            "100000": {
              "other": "000 tuhat"
            },
            "1000000": {
              "one": "0 miljon",
              "other": "0 miljonit"
            },
            "10000000": {
              "other": "00 miljonit"
            },
            "100000000": {
              "other": "000 miljonit"
            },
            "1000000000": {
              "one": "0 miljard",
              "other": "0 miljardit"
            },
            "10000000000": {
              "other": "00 miljardit"
            },
            "100000000000": {
              "other": "000 miljardit"
            },
            "1000000000000": {
              "one": "0 triljon",
              "other": "0 triljonit"
            },
            "10000000000000": {
              "other": "00 triljonit"
            },
            "100000000000000": {
              "other": "000 triljonit"
            }
          },
          "short": {
            "1000": {
              "other": "0 tuh"
            },
            "10000": {
              "other": "00 tuh"
            },
            "100000": {
              "other": "000 tuh"
            },
            "1000000": {
              "other": "0 mln"
            },
            "10000000": {
              "other": "00 mln"
            },
            "100000000": {
              "other": "000 mln"
            },
            "1000000000": {
              "other": "0 mld"
            },
            "10000000000": {
              "other": "00 mld"
            },
            "100000000000": {
              "other": "000 mld"
            },
            "1000000000000": {
              "other": "0 trln"
            },
            "10000000000000": {
              "other": "00 trln"
            },
            "100000000000000": {
              "other": "000 trln"
            }
          },
          "standard": "#,##0.###"
        }
      },
      "nu": [
        "latn"
      ],
      "percent": {
        "latn": "#,##0%"
      },
      "symbols": {
        "latn": {
          "approximatelySign": "≈",
          "decimal": ",",
          "exponential": "×10^",
          "group": " ",
          "infinity": "∞",
          "list": ";",
          "minusSign": "−",
          "nan": "NaN",
          "perMille": "‰",
          "percentSign": "%",
          "plusSign": "+",
          "rangeSign": "‒",
          "superscriptingExponent": "×",
          "timeSeparator": ":"
        }
      }
    },
    "units": {
      "compound": {
        "per": {
          "long": "{0} {1} kohta",
          "narrow": "{0}/{1}",
          "short": "{0}/{1}"
        }
      },
      "simple": {
        "acre": {
          "long": {
            "one": "{0} aaker",
            "other": "{0} aakrit"
          },
          "narrow": {
            "one": "{0} aaker",
            "other": "{0} aakrit"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ac"
          }
        },
        "bit": {
          "long": {
            "one": "{0} bitt",
            "other": "{0} bitti"
          },
          "narrow": {
            "other": "{0} b"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} b"
          }
        },
        "byte": {
          "long": {
            "one": "{0} bait",
            "other": "{0} baiti"
          },
          "narrow": {
            "other": "{0} B"
          },
          "perUnit": {
          },
          "short": {
            "one": "{0} bait",
            "other": "{0} baiti"
          }
        },
        "celsius": {
          "long": {
            "one": "{0} Celsiuse kraad",
            "other": "{0} Celsiuse kraadi"
          },
          "narrow": {
            "other": "{0} °C"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} °C"
          }
        },
        "centimeter": {
          "long": {
            "one": "{0} sentimeeter",
            "other": "{0} sentimeetrit"
          },
          "narrow": {
            "other": "{0} cm"
          },
          "perUnit": {
            "long": "{0} sentimeetri kohta",
            "narrow": "{0}/cm",
            "short": "{0}/cm"
          },
          "short": {
            "other": "{0} cm"
          }
        },
        "day": {
          "long": {
            "one": "{0} ööpäev",
            "other": "{0} ööpäeva"
          },
          "narrow": {
            "other": "{0} p"
          },
          "perUnit": {
            "long": "{0} ööpäevas",
            "narrow": "{0}/ööp",
            "short": "{0}/ööp"
          },
          "short": {
            "one": "{0} päev",
            "other": "{0} päeva"
          }
        },
        "degree": {
          "long": {
            "one": "{0} kraad",
            "other": "{0} kraadi"
          },
          "narrow": {
            "other": "{0}°"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°"
          }
        },
        "fahrenheit": {
          "long": {
            "one": "{0} Fahrenheiti kraad",
            "other": "{0} Fahrenheiti kraadi"
          },
          "narrow": {
            "other": "{0} °F"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} °F"
          }
        },
        "fluid-ounce": {
          "long": {
            "one": "{0} vedelikuunts",
            "other": "{0} vedelikuuntsi"
          },
          "narrow": {
            "other": "{0} fl oz"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} fl oz"
          }
        },
        "foot": {
          "long": {
            "one": "{0} jalg",
            "other": "{0} jalga"
          },
          "narrow": {
            "one": "{0} jalg",
            "other": "{0} jalga"
          },
          "perUnit": {
            "long": "{0} jala kohta",
            "narrow": "{0}/ft",
            "short": "{0}/ft"
          },
          "short": {
            "other": "{0} ft"
          }
        },
        "gallon": {
          "long": {
            "one": "{0} gallon",
            "other": "{0} gallonit"
          },
          "narrow": {
            "other": "{0} gal"
          },
          "perUnit": {
            "long": "{0} galloni kohta",
            "narrow": "{0}/gal",
            "short": "{0}/gal"
          },
          "short": {
            "other": "{0} gal"
          }
        },
        "gigabit": {
          "long": {
            "one": "{0} gigabitt",
            "other": "{0} gigabitti"
          },
          "narrow": {
            "other": "{0} Gb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Gb"
          }
        },
        "gigabyte": {
          "long": {
            "one": "{0} gigabait",
            "other": "{0} gigabaiti"
          },
          "narrow": {
            "other": "{0} GB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} GB"
          }
        },
        "gram": {
          "long": {
            "one": "{0} gramm",
            "other": "{0} grammi"
          },
          "narrow": {
            "other": "{0} g"
          },
          "perUnit": {
            "long": "{0} grammi kohta",
            "narrow": "{0}/g",
            "short": "{0}/g"
          },
          "short": {
            "other": "{0} g"
          }
        },
        "hectare": {
          "long": {
            "one": "{0} hektar",
            "other": "{0} hektarit"
          },
          "narrow": {
            "other": "{0} ha"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ha"
          }
        },
        "hour": {
          "long": {
            "one": "{0} tund",
            "other": "{0} tundi"
          },
          "narrow": {
            "other": "{0} t"
          },
          "perUnit": {
            "long": "{0} tunnis",
            "narrow": "{0}/t",
            "short": "{0}/t"
          },
          "short": {
            "other": "{0} t"
          }
        },
        "inch": {
          "long": {
            "one": "{0} toll",
            "other": "{0} tolli"
          },
          "narrow": {
            "one": "{0} toll",
            "other": "{0} tolli"
          },
          "perUnit": {
            "long": "{0} tolli kohta",
            "narrow": "{0}/in",
            "short": "{0}/in"
          },
          "short": {
            "other": "{0} in"
          }
        },
        "kilobit": {
          "long": {
            "one": "{0} kilobitt",
            "other": "{0} kilobitti"
          },
          "narrow": {
            "other": "{0} kb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kb"
          }
        },
        "kilobyte": {
          "long": {
            "one": "{0} kilobait",
            "other": "{0} kilobaiti"
          },
          "narrow": {
            "other": "{0} kB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kB"
          }
        },
        "kilogram": {
          "long": {
            "one": "{0} kilogramm",
            "other": "{0} kilogrammi"
          },
          "narrow": {
            "other": "{0} kg"
          },
          "perUnit": {
            "long": "{0} kilogrammi kohta",
            "narrow": "{0}/kg",
            "short": "{0}/kg"
          },
          "short": {
            "other": "{0} kg"
          }
        },
        "kilometer": {
          "long": {
            "one": "{0} kilomeeter",
            "other": "{0} kilomeetrit"
          },
          "narrow": {
            "other": "{0} km"
          },
          "perUnit": {
            "long": "{0} kilomeetri kohta",
            "narrow": "{0}/km",
            "short": "{0}/km"
          },
          "short": {
            "other": "{0} km"
          }
        },
        "kilometer-per-hour": {
          "long": {
            "one": "{0} kilomeeter tunnis",
            "other": "{0} kilomeetrit tunnis"
          },
          "narrow": {
            "other": "{0} km/h"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} km/h"
          }
        },
        "liter": {
          "long": {
            "one": "{0} liiter",
            "other": "{0} liitrit"
          },
          "narrow": {
            "other": "{0} l"
          },
          "perUnit": {
            "long": "{0} liitri kohta",
            "narrow": "{0}/l",
            "short": "{0}/l"
          },
          "short": {
            "other": "{0} l"
          }
        },
        "liter-per-kilometer": {
          "long": {
            "one": "{0} liiter kilomeetri kohta",
            "other": "{0} liitrit kilomeetri kohta"
          },
          "narrow": {
            "other": "{0} l/km"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} l/km"
          }
        },
        "megabit": {
          "long": {
            "one": "{0} megabitt",
            "other": "{0} megabitti"
          },
          "narrow": {
            "other": "{0} Mb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Mb"
          }
        },
        "megabyte": {
          "long": {
            "one": "{0} megabait",
            "other": "{0} megabaiti"
          },
          "narrow": {
            "other": "{0} MB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} MB"
          }
        },
        "meter": {
          "long": {
            "one": "{0} meeter",
            "other": "{0} meetrit"
          },
          "narrow": {
            "other": "{0} m"
          },
          "perUnit": {
            "long": "{0} meetri kohta",
            "narrow": "{0}/m",
            "short": "{0}/m"
          },
          "short": {
            "other": "{0} m"
          }
        },
        "meter-per-second": {
          "long": {
            "one": "{0} meeter sekundis",
            "other": "{0} meetrit sekundis"
          },
          "narrow": {
            "other": "{0} m/s"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} m/s"
          }
        },
        "mile": {
          "long": {
            "one": "{0} miil",
            "other": "{0} miili"
          },
          "narrow": {
            "one": "{0} miil",
            "other": "{0} miili"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mi"
          }
        },
        "mile-per-gallon": {
          "long": {
            "one": "{0} miil galloni kohta",
            "other": "{0} miili galloni kohta"
          },
          "narrow": {
            "other": "{0} mpg"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mpg"
          }
        },
        "mile-per-hour": {
          "long": {
            "one": "{0} miil tunnis",
            "other": "{0} miili tunnis"
          },
          "narrow": {
            "other": "{0} mi/h"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mi/h"
          }
        },
        "mile-scandinavian": {
          "long": {
            "one": "{0} Skandinaavia miil",
            "other": "{0} Skandinaavia miili"
          },
          "narrow": {
            "other": "{0} smi"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} smi"
          }
        },
        "milliliter": {
          "long": {
            "one": "{0} milliliiter",
            "other": "{0} milliliitrit"
          },
          "narrow": {
            "other": "{0} ml"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ml"
          }
        },
        "millimeter": {
          "long": {
            "one": "{0} millimeeter",
            "other": "{0} millimeetrit"
          },
          "narrow": {
            "other": "{0} mm"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mm"
          }
        },
        "millisecond": {
          "long": {
            "one": "{0} millisekund",
            "other": "{0} millisekundit"
          },
          "narrow": {
            "other": "{0} ms"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ms"
          }
        },
        "minute": {
          "long": {
            "one": "{0} minut",
            "other": "{0} minutit"
          },
          "narrow": {
            "other": "{0} min"
          },
          "perUnit": {
            "long": "{0} minutis",
            "narrow": "{0}/min",
            "short": "{0}/min"
          },
          "short": {
            "other": "{0} min"
          }
        },
        "month": {
          "long": {
            "one": "{0} kuu",
            "other": "{0} kuud"
          },
          "narrow": {
            "other": "{0} k"
          },
          "perUnit": {
            "long": "{0} kuus",
            "narrow": "{0}/k",
            "short": "{0}/k"
          },
          "short": {
            "one": "{0} kuu",
            "other": "{0} kuud"
          }
        },
        "ounce": {
          "long": {
            "one": "{0} unts",
            "other": "{0} untsi"
          },
          "narrow": {
            "other": "{0} oz"
          },
          "perUnit": {
            "long": "{0} untsi kohta",
            "narrow": "{0}/oz",
            "short": "{0}/oz"
          },
          "short": {
            "other": "{0} oz"
          }
        },
        "percent": {
          "long": {
            "one": "{0} protsent",
            "other": "{0} protsenti"
          },
          "narrow": {
            "other": "{0}%"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}%"
          }
        },
        "petabyte": {
          "long": {
            "one": "{0} petabait",
            "other": "{0} petabaiti"
          },
          "narrow": {
            "other": "{0} PB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} PB"
          }
        },
        "pound": {
          "long": {
            "one": "{0} nael",
            "other": "{0} naela"
          },
          "narrow": {
            "other": "{0} lb"
          },
          "perUnit": {
            "long": "{0} naela kohta",
            "narrow": "{0}/lb",
            "short": "{0}/lb"
          },
          "short": {
            "other": "{0} lb"
          }
        },
        "second": {
          "long": {
            "one": "{0} sekund",
            "other": "{0} sekundit"
          },
          "narrow": {
            "other": "{0} s"
          },
          "perUnit": {
            "long": "{0} sekundis",
            "narrow": "{0}/s",
            "short": "{0}/sek"
          },
          "short": {
            "other": "{0} sek"
          }
        },
        "stone": {
          "long": {
            "other": "{0} kivi"
          },
          "narrow": {
            "other": "{0} st"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} st"
          }
        },
        "terabit": {
          "long": {
            "one": "{0} terabitt",
            "other": "{0} terabitti"
          },
          "narrow": {
            "other": "{0} Tb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Tb"
          }
        },
        "terabyte": {
          "long": {
            "one": "{0} terabait",
            "other": "{0} terabaiti"
          },
          "narrow": {
            "other": "{0} TB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} TB"
          }
        },
        "week": {
          "long": {
            "one": "{0} nädal",
            "other": "{0} nädalat"
          },
          "narrow": {
            "other": "{0} n"
          },
          "perUnit": {
            "long": "{0} nädalas",
            "narrow": "{0}/näd",
            "short": "{0}/näd"
          },
          "short": {
            "other": "{0} näd"
          }
        },
        "yard": {
          "long": {
            "one": "{0} jard",
            "other": "{0} jardi"
          },
          "narrow": {
            "one": "{0} jard",
            "other": "{0} jardi"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} yd"
          }
        },
        "year": {
          "long": {
            "one": "{0} aasta",
            "other": "{0} aastat"
          },
          "narrow": {
            "other": "{0} a"
          },
          "perUnit": {
            "long": "{0} aastas",
            "narrow": "{0}/a",
            "short": "{0}/a"
          },
          "short": {
            "other": "{0} a"
          }
        }
      }
    }
  },
  "locale": "et"
})
}